import { useSelector } from 'react-redux'
import props from '../../../../../../redux/props'

export enum ChartType {
  PIE = 'PIE',
  BAR = 'BAR',
  BAR_CLUSTER = 'BAR_CLUSTER',
  RELATIONSHIP = 'RELATIONSHIP',
}

type Props = { availableOptions?: ChartType[]; activeChart?: ChartType; setActiveChart?: (type: ChartType) => void }

const ChartSelector: React.FC<Props> = ({ availableOptions, activeChart, setActiveChart }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  if (!availableOptions || !activeChart || !setActiveChart) return <></>
  return (
    <div className="relative">
      <div className="flex gap-2">
        {availableOptions.includes(ChartType.PIE) && (
          <button
            className={`px-2 py-1 rounded-md text-sm ${activeChart === ChartType.PIE ? 'bg-cyan text-white' : 'bg-gray-200 text-gray-800'}`}
            onClick={() => setActiveChart(ChartType.PIE)}
          >
            {t.survey.analysis.chartSelector.types[ChartType.PIE]}
          </button>
        )}
        {availableOptions.includes(ChartType.BAR) && (
          <button
            className={`px-2 py-1 rounded-md text-sm ${activeChart === ChartType.BAR ? 'bg-cyan text-white' : 'bg-gray-200 text-gray-800'}`}
            onClick={() => setActiveChart(ChartType.BAR)}
          >
            {t.survey.analysis.chartSelector.types[ChartType.BAR]}
          </button>
        )}
        {availableOptions.includes(ChartType.BAR_CLUSTER) && (
          <button
            className={`px-2 py-1 rounded-md text-sm ${activeChart === ChartType.BAR_CLUSTER ? 'bg-cyan text-white' : 'bg-gray-200 text-gray-800'}`}
            onClick={() => setActiveChart(ChartType.BAR_CLUSTER)}
          >
            {t.survey.analysis.chartSelector.types[ChartType.BAR_CLUSTER]}
          </button>
        )}
        {availableOptions.includes(ChartType.RELATIONSHIP) && (
          <button
            className={`px-2 py-1 rounded-md text-sm ${activeChart === ChartType.RELATIONSHIP ? 'bg-cyan text-white' : 'bg-gray-200 text-gray-800'}`}
            onClick={() => setActiveChart(ChartType.RELATIONSHIP)}
          >
            {t.survey.analysis.chartSelector.types[ChartType.RELATIONSHIP]}
          </button>
        )}
      </div>
    </div>
  )
}

export default ChartSelector
